import { render } from "./Bed.vue?vue&type=template&id=76a9f58a&scoped=true"
import script from "./Bed.vue?vue&type=script&lang=js"
export * from "./Bed.vue?vue&type=script&lang=js"

import "./Bed.vue?vue&type=style&index=0&id=76a9f58a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a9f58a"]])

export default __exports__